/**
 * @graphql cc
 */
import gql from 'graphql-tag';

import { useQueryInterop as useQuery } from '@confluence/apollo-relay-interop';
import { useSessionData } from '@confluence/session-data';
import { markErrorAsHandled } from '@confluence/graphql/entry-points/markErrorAsHandled';
import { getMonitoringClient } from '@confluence/monitoring/entry-points/getMonitoringClient';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution';
import { fg } from '@confluence/feature-gating';

import {
	ConfluenceSpaceRoleMode,
	type useSpaceRoleModeQueryVariables as useSpaceRoleModeQueryVariables$variables,
	type useSpaceRoleModeQuery_Query as useSpaceRoleModeQuery_Query$data,
} from './__types__/useSpaceRoleModeQuery';

const useSpaceRoleModeQuery = gql`
	query useSpaceRoleModeQuery($cloudId: ID!) {
		confluence_spaceRoleMode(cloudId: $cloudId)
	}
`;

export const useSpaceRoleMode = () => {
	const { cloudId } = useSessionData();
	const { data, loading } = useQuery<
		useSpaceRoleModeQuery_Query$data,
		useSpaceRoleModeQueryVariables$variables
	>(useSpaceRoleModeQuery, {
		variables: { cloudId },
		onError: (error) => {
			getMonitoringClient().submitError(error, {
				attribution: Attribution.PERMISSIONS_EXPERIENCE,
			});
			markErrorAsHandled(error);
		},
	});

	const isNotPreRoles = data?.confluence_spaceRoleMode
		? data.confluence_spaceRoleMode !== ConfluenceSpaceRoleMode.PRE_ROLES
		: false;

	const isBetaFastFollowEnabled =
		data?.confluence_spaceRoleMode === ConfluenceSpaceRoleMode.ROLES ||
		fg('confluence_rbac_spaces_beta_fastfollow');

	return {
		spaceRoleMode: data?.confluence_spaceRoleMode,
		isRbacEnabled: isNotPreRoles,
		isBetaFastFollowEnabled,
		loading,
	};
};
